export const WorkoutPlayerContextPanel = {
  bindings: {
    workout: '<',
    steps: '<',
    currentStep: '<',
    currentStepIndex: '<',
    exercises: '<',
    onClick: '&',
  },

  template: `
    <div class="workout-player-context-panel">
      <div class="context-panel-inner">
        <div
          ng-repeat="group in $ctrl.workout.items track by $index"
          ng-if="group.name !== 'Transition'">
          <h3 class="group-title">
            <span class="bar"></span>
            <span>{{ group.name }}</span>
            <span class="bar"></span>
          </h3>
          <ul class="list-unstyled">
            <li
              ng-repeat="item in group.items track by $index"
              ng-if="item.name !== 'Transition' && !item.duplicate",
              ng-class="{ 'active': item.id === $ctrl.currentStep.id || item.id === $ctrl.currentStep.parentId }"
              ng-switch="item.items.length > 0"
              ng-attr-id="{{ 'item-' + item.id }}">
              <!-- Single item -->
              <div class="single-item"
                ng-switch-when="false"
                ng-click="(item.id === $ctrl.currentStep.id) && $ctrl.onClick()">
                <workout-player-context-item
                  data="$ctrl.exercises[item.exerciseId]">
                </workout-player-context-item>
              </div>
              <!-- Super set -->
              <div ng-switch-when="true">
                <div class="superset">
                  {{ item.repsCount }}x {{ item.name }}
                  <span class="sets">
                    {{ $ctrl.data.getSetTitle(item) }}
                  </span>
                </div>
                <ul class="list-unstyled">
                  <li
                    ng-repeat="leaf in item.items track by $index"
                    ng-if="!leaf.duplicate"
                    ng-class="{'active': leaf.id === $ctrl.currentStep.id}"
                    ng-attr-id="{{ 'item-' + leaf.id }}">
                    <div class="single-item"
                      ng-click="(leaf.id === $ctrl.currentStep.id) && $ctrl.onClick()">
                      <workout-player-context-item
                        data="$ctrl.exercises[leaf.exerciseId]">
                      </workout-player-context-item>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>`,

  controller($element) {
    'ngInject';

    return {
      $onChanges(changes) {
        if (this.currentStep && changes.currentStepIndex) {
          this.animate(this.currentStep.id);
        }
      },

      animate(id) {
        const $el = $element.find(`#item-${id}`);

        let offset = 0;

        if ($el.index() === 0) {
          offset = $element.find('.group-title').height();
        }

        if ($el.position()) {
          offset = offset - $el.position().top;
        }

        $element.find('.context-panel-inner').animate(
          { translateY: offset },
          {
            speed: 400,
            step: function animateContextPanel(now) {
              $(this).css('transform', `translate3d(0, ${now}px, 0)`);
            },
          }
        );
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/WorkoutPlayer/WorkoutPlayerContextPanel.js